import { render, staticRenderFns } from "./UnitatiMasura.vue?vue&type=template&id=f2273db8"
import script from "./UnitatiMasura.vue?vue&type=script&lang=js"
export * from "./UnitatiMasura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports